﻿import jquery from 'jquery';


class AlertsRepository {
    
    constructor(alertsRepositoryDto){

        this._alertsRepositoryDto = alertsRepositoryDto;

    }

    registrarAlerta(form){

        return new Promise((resolve, reject) => {
            
            jquery.post(this._alertsRepositoryDto.UrlRegistrarAlerta, form.serialize()
                , (data) => {
                    if(data.status === 0){
                        resolve(data);
                    } else{
                        reject();
                    }
                }, 'json');
        
        });
        
    }


}

export default AlertsRepository;


